export const getCoverageTitle = (coverageVariation,
  coverageList,
  coverageMerge,
  variant,
  newCoverageCode,
  showTitle) => {
  let title = '';
  if (showTitle &&
    (coverageList[newCoverageCode] || (coverageMerge && coverageMerge[newCoverageCode]))) {
    title =
    coverageList[newCoverageCode] ?
      coverageList[newCoverageCode].name :
      coverageMerge[newCoverageCode].name;
    if (variant === 'modal' && (
      coverageList[newCoverageCode].modalTitle ||
    (coverageMerge &&
      coverageMerge[newCoverageCode] &&
      coverageMerge[newCoverageCode].modalTitle)
    )) {
      title =
        coverageList[newCoverageCode] ?
          coverageList[newCoverageCode].modalTitle :
          coverageMerge[newCoverageCode].modalTitle;
    }
  }
  return title;
};